// extracted by mini-css-extract-plugin
export default {"element":"Raw-module--element--1683b","disableMinHeight":"Raw-module--disableMinHeight--a3a73"};